import React from 'react';
import { Stars } from './QuickTestimonials';
type Testimonial = {
  initials: string;
  quote: string;
  name: string;
  location: string;
};
const TESTIMONIALS: Testimonial[] = [{
  initials: 'DM',
  quote: 'I used to spend most of Sunday organizing the following week. Now I select the right session, adapt it to my players, and I’m ready.',
  name: 'David M.',
  location: 'Los Angeles, USA'
}, {
  initials: 'TB',
  quote: 'The drill library gives me far more structure. Every exercise has a clear objective instead of just filling time on court.',
  name: 'Thomas B.',
  location: 'Melbourne, Australia'
}, {
  initials: 'OC',
  quote: 'The tactical material is what made the biggest difference. I can turn problems I see during matches into specific training sessions.',
  name: 'Oliver C.',
  location: 'Auckland, New Zealand'
}, {
  initials: 'RH',
  quote: 'I coach players with very different needs. Having progressions and adaptations ready makes my sessions much easier to organize.',
  name: 'Ryan H.',
  location: 'Toronto, Canada'
}, {
  initials: 'JW',
  quote: 'I had years of drills and notes scattered across different places. Now everything I actually need is organized in one system.',
  name: 'James W.',
  location: 'Manchester, UK'
}, {
  initials: 'DS',
  quote: 'The Session Design System is incredibly practical. It saves preparation time without making my sessions feel repetitive.',
  name: 'Daniel S.',
  location: 'Sydney, Australia'
}, {
  initials: 'MC',
  quote: 'I run eighteen hours of court time a week between a club and two private pairs, and preparation was quietly taking over my evenings. Now I open the session library, pick the objective and the format I need, adjust two or three constraints for the players in front of me, and I walk on court with a clear plan. My sessions are sharper and my week is finally under control.',
  name: 'Martin C.',
  location: 'Calgary, Canada'
}, {
  initials: 'AP',
  quote: 'At 44 I moved from tennis coaching into padel full time, and the hardest part was never the intensity — it was having a real methodology behind the bandeja, the walls, and the transitions. The technical progressions gave me that in a few weeks. My players finally understand why we are doing each exercise, and three of them moved up a category this season.',
  name: 'Andrew P.',
  location: 'Birmingham, United Kingdom'
}, {
  initials: 'LK',
  quote: 'Most of my work is with competitive pairs, so coordination and roles matter more than isolated shots. The pair development bonus gave me structures for communication, coverage, and positioning that I can run straight from the sheet. Two of my pairs reached their first regional final this year and the difference was tactical, not physical.',
  name: 'Lucas K.',
  location: 'Auckland, New Zealand'
}, {
  initials: 'SG',
  quote: 'I coach group sessions of six to eight players and keeping everyone working with purpose used to be my biggest challenge. The session design system lets me plan rotations, workload, and adaptations in advance, so nobody stands around. Attendance at my Tuesday and Thursday groups has been full for four months straight.',
  name: 'Stefan G.',
  location: 'Brisbane, Australia'
}, {
  initials: 'PR',
  quote: 'The assessment and match analysis tools changed how I speak to my players. Instead of vague feedback I show them error patterns, priorities, and a twelve-week plan they can actually follow. Renewals went up because people can see their own progress written down, and that alone paid for the system many times over.',
  name: 'Peter R.',
  location: 'Edinburgh, United Kingdom'
}];
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="w-full bg-ivory px-4 py-8 sm:px-6" data-id="element-224" data-mp="2519yn91h04qc">
      <div className="mx-auto max-w-6xl" data-id="element-225" data-mp="1lwn8f2nla3rl">
        <div className="text-center" data-id="element-226" data-mp="1lxoip4ws6m89">
          <span className="font-head text-[11px] font-semibold uppercase tracking-wider text-brand sm:text-xs" data-id="element-227" data-mp="1lukcy33o3ifh">
            Trusted by padel coaches
          </span>
          <h2 id="testimonials-title" className="mt-1 font-display text-3xl uppercase leading-none text-charcoal sm:text-4xl" data-id="element-228" data-mp="1vo9g4p0pxkpl">
            What coaches are saying
          </h2>
          <p className="mt-1 flex items-center justify-center gap-2 text-[13px] font-semibold text-charcoal" data-id="element-229" data-mp="24phet875cnk7">
            <Stars data-id="element-230" data-mp="1zqnyz94e0kgv" />
            4.9/5 · 564+ Padel Coaches
          </p>
          <p className="mt-1 font-head text-[10px] font-semibold uppercase tracking-wider text-softgray" data-id="element-231" data-mp="2el2ciu56n1o5">
            Sample testimonial — replace with verified customer
          </p>
        </div>

        <div className="mt-4 grid gap-2.5 md:grid-cols-2 lg:grid-cols-3" data-id="element-232" data-mp="k82yv6kd4hji">
          {TESTIMONIALS.map(item => <figure key={item.name} className="flex flex-col rounded-xl border border-charcoal/10 bg-white p-3.5" data-id="element-233" data-mp="fajcfjdigygh">
              <div className="flex items-center gap-2" data-id="element-234" data-mp="2vtv37olr6m5y">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-dark font-head text-xs font-semibold text-white" data-id="element-235" data-mp="2vwprjr7w0r4n">
                  {item.initials}
                </span>
                <Stars data-id="element-236" data-mp="285bux92pe9dv" />
              </div>
              <blockquote className="mt-1.5 text-[13px] leading-snug text-charcoal" data-id="element-237" data-mp="28498pegbsv4a">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-2 font-head text-xs font-semibold uppercase text-charcoal" data-id="element-238" data-mp="2c4kp2f1no99y">
                {item.name}
                <span className="block font-body text-[11px] font-normal normal-case text-softgray" data-id="element-239" data-mp="235phayiyqr4j">
                  {item.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}